export const TipoMuestra = {
  PUNTUAL: "PUNTUAL",
  COMPUESTA: "COMPUESTA",
  COMPENSADA: "COMPENSADA",
};

export const PeriodicidadVuelco = {
  SEMANAL: "SEMANAL",
  DISCONTINUO: "DISCONTINUO",
  DIARIO: "DIARIO",
  PERMANENTE: "PERMANENTE",
  MENSUAL: "MENSUAL",
};

export const DestinoVuelco = {
  CLOACAL: "CLOACAL",
  SUELO: "SUELO",
  SUPERFICIAL: "SUPERFICIAL",
};
export const DestinoResiduoTratamiento = {
  INTERNO: "INTERNO",
  EXTERNO: "EXTERNO",
};
export const CercoPerimetral = {
  MURO_SOLIDO_MENOR_25M: "MURO_SOLIDO_MENOR_25M",
  MURO_SOLIDO_MAYOR_25M: "MURO_SOLIDO_MAYOR_25M",
  CERCO_ARBOLES: "CERCO_ARBOLES",
};
export const TipoTramite = {
  DJE: "DJE",
  DJG: "DJG",
  DJA: "DJA",
  DJEELL: "DJEELL",
  DJEEGG: "DJEEGG",
  DJRR: "DJRR",
};

export const EstadoTramite = {
  INICIADO: "INICIADO",
  PENDIENTE: "PENDIENTE",
  FINALIZADO: "FINALIZADO",
  PRESENTADO: "PRESENTADO",
  APROBADO: "APROBADO",
  RECHAZADO: "RECHAZADO",
  CANCELADO: "CANCELADO",
};

export const CategoriaAmbiental = {
  PRIMERA: "PRIMERA",
  SEGUNDA: "SEGUNDA",
  TERCERA: "TERCERA",
  CRE: "CRE",
  SRE: "SRE",
  SRECC: "SRECC",
  SC: "SC",
  CDDJJ: "CDDJJ",
  RCI: "RCI",
  NO_APLICA: "NO_APLICA",
};
